import { render } from "./recipient-form.vue?vue&type=template&id=6b01f8ef"
import script from "./recipient-form.vue?vue&type=script&lang=js"
export * from "./recipient-form.vue?vue&type=script&lang=js"

import "./recipient-form.vue?vue&type=style&index=0&id=6b01f8ef&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__